export default __webpack_public_path__ + "static/media/Activity.244a0cf0.svg";